<template>
  <MonitorList :system="true"></MonitorList>
</template>

<script>
import MonitorList from '../monitor/List.vue'

export default {
  components: {
    MonitorList
  }
}
</script>
